export default "__VITE_ASSET__5c16f7c7__"